var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_TrialBalanceCheck"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _c(
          "div",
          { staticStyle: { margin: "10px 10px 10px 10px", height: "300px" } },
          [
            _c(
              "span",
              { style: "margin: 20px 0 60px 0;" + _vm.msgLabelStyle },
              [_vm._v(_vm._s(_vm.msgLabel))]
            ),
            _c(
              "el-table",
              {
                attrs: {
                  data: [_vm.data],
                  border: "",
                  "header-cell-style": {
                    height: "80px",
                    "text-align": "center"
                  },
                  "cell-style": { height: "80px", "text-align": "center" }
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "item",
                    label: _vm.$t("CargoMsg.Cargo_Item"),
                    width: "180"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "debit",
                    label: _vm.$t("CargoMsg.Cargo_DebitAmountCN"),
                    width: "180"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "credt",
                    label: _vm.$t("CargoMsg.Cargo_CreditAmountCN"),
                    width: "180"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "balance",
                    label: _vm.$t("CargoMsg.Cargo_Difference"),
                    width: "180"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }